/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/custom_event_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/custom_event_remote_lookup_provider.rb) */
export const idTypeSchema = z.string();

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/custom_event_remote_lookup_provider.rb) */
export const idTypeOutputSchema = z.string();
